import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import Popup from "reactjs-popup";
import {DebounceInput} from 'react-debounce-input';
import DatePicker from "react-datepicker";
import Flatpickr from "react-flatpickr";
import { confirmDateTimePickerProps } from "../../../shared/confirmDateTimePicker";
import { toastError } from "../../../shared/toastHelper";
import RoomSelector from '../../../shared/RoomSelector';
import EventTemplateSelect from '../../../shared/EventTemplateSelect';

import {
  offsetDateForBrowser
} from '../../../shared/timeZoneLogic';
import { applyDefaultStart } from '../../EventForm/actions/eventFormActionCreators';
import { canSubmitHoldRemoval } from '../../EventPage/components/actions/holdActionValidation';
import { Button, CheckCircle, ChevronDown, Trash01 } from '@opendate-app/setlist';

const flatPickrFormat = "n/j/y at h:iK"
var moment = require('moment');

const canSubmitHoldToConfirmSave = function(
  holdToConfirm,
  isConvertingHoldToConfirm,
  selectedRooms
){
  return (
    holdToConfirm
      && holdToConfirm.start_time
      && holdToConfirm.door_time
      && holdToConfirm.end_time
      && holdToConfirm.selectedHoldPositionId
      && selectedRooms && selectedRooms.length > 0
      && !isConvertingHoldToConfirm
  );
}

const modalContentStyle = {
  "background": "var(--sl-bg-primary)",
  "textAlign": "left",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "360px",
  "padding": "15px"
}

const holdToConfirmModalContentStyle = {
  "background": "var(--sl-bg-primary)",
  "textAlign": "left",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "594px",
  "padding": "0px"
}

const popupContentStyle = {
  "background": "var(--sl-bg-primary)",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "250px",
  "padding": "4px 0",
  "zIndex": 9999
}

const deleteModalContentStyle = {
  "textAlign": "left",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "500px",
  "padding": "15px"
}

const HoldActionMenu = ({
  confirm,
  csrfToken,
  team,
  currentUser,
  holdGroupDeletion,
  holdGroupDeletionChanged,
  deleteHoldGroup,
  holdToConfirm,
  holdToConfirmChanged,
  userChangedDoorsTimeChanged,
  userChangedEventEndTimeChanged,
  convertHoldGroupToConfirm,
  isConvertingHoldToConfirm,
  venueOwnerships,
  rooms,
  eventTimeDefaults
}) => {
  const [selectedRooms, setSelectedRooms] = useState(
    rooms.filter((r) =>
      (confirm.room_ids || []).includes(r.id)
    ).map((r) => {
      return {
        value: r.id,
        label: r.name,
        room: r,
        venueOwnershipId: r.venue_ownership_id
      };
    })
  );

  const dateTimePickerProps = (value, onDates) => confirmDateTimePickerProps({
    typedEntry: team.calendar_typed_date_entry_enabled,
    dateFormat: flatPickrFormat,
    minDate: offsetDateForBrowser(new Date()),
    value,
    onDates,
    onInvalidEntry: toastError
  });

  useEffect(() => {
    if (holdToConfirm && holdToConfirm.room_ids) {
      const newSelectedRooms = rooms.filter((r) =>
        (holdToConfirm.room_ids || []).includes(r.id)
      ).map((r) => {
        return {
          value: r.id,
          label: r.name,
          room: r,
          venueOwnershipId: r.venue_ownership_id
        };
      });
      setSelectedRooms(newSelectedRooms);
    }
  }, [holdToConfirm, rooms]);

  return (
    <>
      <Popup arrow={false}
            offsetY={5}
            position="bottom right"
            contentStyle={popupContentStyle}
            onOpen={
              (e) => {
                e.stopPropagation();
                e.preventDefault();
              }
            }
            trigger={open => (
              <span className="classic-actions-trigger">
                <Button variant="primary" trailingIcon={ChevronDown}>Actions</Button>
              </span>
            )} >
        {close => (
          <div className='row text-left'>
            <div className="col-12">
              <ul className="list-group classic-actions-menu">
                {currentUser.can_create_calendar_event ? (
                  <li className="list-group-item">
                    <a href="#"
                        onClick={
                          (e) => {
                            e.preventDefault();

                            var eventTemplate = (confirm.event_template && confirm.event_template.id ?
                              { value: confirm.event_template.id, label: confirm.event_template.name }
                            : null);

                            var holdToConfirm = {
                              ...confirm,
                              event_template: eventTemplate,
                              room_ids: confirm.room_ids || []
                            };

                            holdToConfirmChanged(holdToConfirm);
                          }
                        }
                        className="text-dark">
                      <CheckCircle width={16} height={16} aria-hidden="true" />
                      Confirm this event
                    </a>
                  </li>
                ) : null}
                {currentUser.can_destroy_calendar_event ? (
                  <li className="list-group-item is-danger">
                    <a href="#"
                        onClick={
                          (e) => {
                            e.preventDefault();
                            holdGroupDeletionChanged({hold_group_id: confirm.id});
                          }
                        }
                        className="text-dark">
                      <Trash01 width={16} height={16} aria-hidden="true" />
                      Remove from calendar
                    </a>
                  </li>
                ) : null}
              </ul>
            </div>
          </div>
        )}
      </Popup>
      <Popup
        open={(Object.keys(holdGroupDeletion).length > 0)}
        contentStyle={modalContentStyle}
        closeOnDocumentClick={true}
        onClose={() => holdGroupDeletionChanged({})}
      >
        <div>
          <div className="text-center">
            <p className="strong mb-0"
               style={{"fontSize": "20px"}}>
              Are you sure?
            </p>
            <p className="text-muted mb-0">
              Confirm deletion of this hold.
            </p>
          </div>
          <form onSubmit={
            (e) => {
              e.preventDefault();

              if(!canSubmitHoldRemoval(holdGroupDeletion, team.require_hold_removal_reason)){
                return false;
              }

              deleteHoldGroup(csrfToken, team, confirm.id, holdGroupDeletion);
            }
          }>
            <div className="form-group mt-4">
              <select className="form-control form-control-sm"
                      style={{
                        "borderColor": "var(--od-c-f5f5f5, #f5f5f5)",
                        "borderRadius": "8px"
                      }}
                      value={holdGroupDeletion.reason || ""}
                      onChange={
                        (e) => {
                          var updated = Object.assign({}, holdGroupDeletion, {
                            reason: e.target.value
                          });

                          holdGroupDeletionChanged(updated);
                        }
                      }
                      id="hold-group-deletion-reason">
                {team.require_hold_removal_reason ? (
                  <option value="" disabled>Reason for deletion</option>
                ) : (
                  <option value="">Reason for deletion (optional)</option>
                )}
                <option value="Skipping the market">Skipping the market</option>
                <option value="Playing another venue in market">Playing another venue in market</option>
                <option value="Tour cancelled">Tour cancelled</option>
                <option value="Other">Other</option>
              </select>
            </div>
            {holdGroupDeletion.reason === "Other" ? (
              <div className="form-group">
                <DebounceInput type="text"
                       debounceTimeout={250}
                       className="form-control form-control-sm"
                       style={{
                         "borderColor": "var(--od-c-f5f5f5, #f5f5f5)",
                         "borderRadius": "8px"
                       }}
                       value={holdGroupDeletion.explanation || ""}
                       onChange={
                         (e) => {
                           var updated = Object.assign({}, holdGroupDeletion, {
                            explanation: e.target.value
                          });

                          holdGroupDeletionChanged(updated);
                         }
                       }
                       id="hold-group-deletion-explanation"
                       placeholder="Please explain..." />
              </div>
            ) : null}
            {confirm && confirm.artists && confirm.artists.length > 0 ? (
              <div className="form-group">
                <div className="form-row">
                  <div className="col-8">
                    <div className="custom-control custom-checkbox">
                      <input type="checkbox"
                             className="custom-control-input"
                             value={holdGroupDeletion.followUp || false}
                             onChange={
                               (e) => {
                                  var updated = Object.assign({}, holdGroupDeletion, {
                                    followUp: e.target.checked
                                  });
        
                                  holdGroupDeletionChanged(updated);
                               }
                             }
                             id="hold-group-deletion-follow-up" />
                      <label className="custom-control-label"
                             htmlFor="hold-group-deletion-follow-up">
                        Schedule Follow-up
                      </label>
                    </div>
                  </div>
                  <div className="col-4">
                    <DatePicker selected={holdGroupDeletion.followUpAt || ""}
                                className="form-control form-control-sm form-control-datepicker-sm"
                                placeholderText="Date"
                                disabled={!holdGroupDeletion.followUp}
                                onChange={
                                  (date) => {
                                    var updated = Object.assign({}, holdGroupDeletion, {
                                      followUpAt: date
                                    });
          
                                    holdGroupDeletionChanged(updated);
                                  }
                                } />
                  </div>
                </div>
              </div>
            ) : null}
            <div className="mt-3 text-right">
              <a href="#" onClick={
                (e) => {
                  e.preventDefault();
                  holdGroupDeletionChanged({});
                }
              }>
                Cancel
              </a>
              <button type="submit"
                      style={{
                        "borderRadius": "8px"
                      }}
                      disabled={!canSubmitHoldRemoval(holdGroupDeletion, team.require_hold_removal_reason)}
                      className="btn btn-primary btn-sm ml-2">
                 Confirm
              </button>
            </div>
          </form>
        </div>
      </Popup>
      <Popup
        open={(Object.keys(holdToConfirm).length > 0)}
        contentStyle={holdToConfirmModalContentStyle}
        closeOnDocumentClick={true}
        className={"popup-modal"}
        onClose={
          () => {
            holdToConfirmChanged({});
            userChangedDoorsTimeChanged(false);
            userChangedEventEndTimeChanged(false);
          }
        }
      >
        <div className="popup-modal-container">
          <div className="row m-0"
                style={{"borderBottom": "1px solid var(--od-c-f3f3f3, #f2f2f2)"}}>
            <div className="col" style={{"padding": "25px"}}>
              <p className='mb-0' style={{"fontSize": "20px"}}>
                <strong>Confirm Event</strong>
              </p>
            </div>
            <div className="col-xs-auto d-flex align-items-center">
              <a href="#"
                className="text-muted"
                style={{
                  "paddingRight": "30px",
                  "fontSize": "20px"
                }}
                onClick={
                  (e) => {
                    e.preventDefault();
                    holdToConfirmChanged({})
                  }
                } >
                <i className="fa fa-times"></i>
              </a>
            </div>
          </div>
          <div className="row m-0">
            <div className="col-12" style={{"padding": "18px 25px"}}>
              {holdToConfirm.step === 2 ? (
                <form onSubmit={
                        (e) => {
                          e.preventDefault();

                          if(!canSubmitHoldToConfirmSave(
                            holdToConfirm,
                            isConvertingHoldToConfirm,
                            selectedRooms
                          )){
                            return false;
                          }

                          convertHoldGroupToConfirm(csrfToken, team, holdToConfirm);
                        }
                      }>
                  <div className="form-group">
                    <label htmlFor="new-event-template" className="text-muted">
                      Template
                      <span className="text-optional pl-2">
                        (optional)
                      </span>
                    </label>
                    <EventTemplateSelect
                      teamId={team.id}
                      id="new-event-template"
                      value={holdToConfirm.event_template || null}
                      onChange={(option) => holdToConfirmChanged({...holdToConfirm, event_template: option})}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="new-event-rooms" className="text-muted">
                      Venue
                    </label>
                    <RoomSelector
                      rooms={rooms}
                      venueOwnerships={venueOwnerships}
                      selectedRooms={selectedRooms}
                      id="new-event-rooms"
                      menuPortalTarget={document.querySelector('body')}
                      onChange={(selected) => {
                        setSelectedRooms(selected || []);
                        holdToConfirmChanged({
                          ...holdToConfirm,
                          room_ids: (selected || []).map(s => s.value)
                        });
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="start_date_and_time" className="text-muted">
                      Event Start Date/Time
                    </label>
                    <div className="flatpickr-date-input px-2 d-flex align-items-center">
                      <div className="pr-2" style={{"fontSize": "18px"}}>
                        <i className="far fa-calendar"></i>
                      </div>
                      <Flatpickr
                        {...dateTimePickerProps(holdToConfirm.start_time, dates => {
                          holdToConfirmChanged({...holdToConfirm, start_time: dates[0]});
                        })}
                        placeholder={"Select date"}
                        value={holdToConfirm.start_time}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="doors_date_and_time" className="text-muted">
                      Doors Date/Time
                    </label>
                    <div className="flatpickr-date-input px-2 d-flex align-items-center">
                      <div className="pr-2" style={{"fontSize": "18px"}}>
                        <i className="far fa-calendar"></i>
                      </div>
                      <Flatpickr
                        {...dateTimePickerProps(holdToConfirm.door_time, dates => {
                          userChangedDoorsTimeChanged(true);
                          holdToConfirmChanged({...holdToConfirm, door_time: dates[0]});
                        })}
                        placeholder={"Select date"}
                        value={holdToConfirm.door_time}
                      />
                    </div>
                  </div>
                  <div className="form-group" style={{"marginBottom": "20px"}}>
                    <label htmlFor="end_date_and_time" className="text-muted">
                      Event End Date/Time
                    </label>
                    <div className="flatpickr-date-input px-2 d-flex align-items-center">
                      <div className="pr-2" style={{"fontSize": "18px"}}>
                        <i className="far fa-calendar"></i>
                      </div>
                      <Flatpickr
                        {...dateTimePickerProps(holdToConfirm.end_time, dates => {
                          userChangedEventEndTimeChanged(true);
                          holdToConfirmChanged({...holdToConfirm, end_time: dates[0]});
                        })}
                        placeholder={"Select date"}
                        value={holdToConfirm.end_time}
                      />
                    </div>
                  </div>
                  <div className="custom-control custom-control-inline custom-checkbox custom-checkbox-table" style={{
                    marginBottom: "20px",
                    display: "flex",
                    alignItems: "center",
                  }}>
                    <input type="checkbox" className="custom-control-input" style={{}}
                      checked={holdToConfirm.clear_holds_on_day || false}
                      onChange={
                        (e) => {
                          holdToConfirmChanged({
                            ...holdToConfirm,
                            clear_holds_on_day: e.target.checked
                          });
                        }
                      }
                      id="clear-other-holds"
                    />
                    <label className="custom-control-label" htmlFor="clear-other-holds" style={{ paddingTop: 2 }}>
                      Clear all relevant holds on this day
                    </label>
                  </div>
                  <button type="submit"
                          disabled={!canSubmitHoldToConfirmSave(
                            holdToConfirm,
                            isConvertingHoldToConfirm,
                            selectedRooms
                          )}
                          className="btn btn-primary btn-block">
                    {isConvertingHoldToConfirm ? (
                      <React.Fragment>
                        <img src="/uploading-loading.gif"
                             className="mr-1"
                             style={{width: "16px"}} />
                        <strong>Saving...</strong>
                      </React.Fragment>
                    ) : (
                      <strong>Save</strong>
                    )}
                  </button>
                </form>
              ) : (
                <form>
                  <p className='text-muted'>Select the date you want to confirm.</p>
                  {confirm.hold_positions.sort((a, b) => {return new Date(a.start_time) - new Date(b.start_time)}).map((holdPosition, index) => (
                    <div key={index} className="custom-control custom-radio">
                      <input type="radio"
                              id={`confirm-hold-position-${holdPosition.id}`}
                              name="confirm-hold-position"
                              checked={holdToConfirm.selectedHoldPositionId === holdPosition.id}
                              onChange={
                                (e) => {
                                  var updated = Object.assign({}, holdToConfirm, {
                                    selectedHoldPositionId: holdPosition.id,
                                    start_time: applyDefaultStart(eventTimeDefaults, offsetDateForBrowser(holdPosition.start_time))
                                  });
        
                                  holdToConfirmChanged(updated);
                                }
                              }
                              className="custom-control-input" />
                      <label className="custom-control-label"
                              style={{"fontSize": "16px"}}
                              htmlFor={`confirm-hold-position-${holdPosition.id}`}>
                        <strong>
                          {moment(offsetDateForBrowser(holdPosition.start_time)).format("MM/DD/YY")} - {`H${holdPosition.position}`}
                        </strong>
                      </label>
                    </div>
                  ))}
                  <a href="#"
                      onClick={
                        (e) => {
                          e.preventDefault();

                          if(!holdToConfirm.selectedHoldPositionId){
                            return false;
                          }

                          var updated = Object.assign({}, holdToConfirm, {
                            step: 2
                          });

                          holdToConfirmChanged(updated);
                        }
                      }
                      style={{"marginTop": "20px"}}
                      className={'btn btn-primary btn-block ' + (holdToConfirm.selectedHoldPositionId ? "" : "disabled")}>
                    <strong>Next</strong>
                  </a>
                </form>
              )}
            </div>
          </div>
        </div>
      </Popup>
    </>
  );
};

HoldActionMenu.propTypes = {
  confirm: PropTypes.object.isRequired,
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  holdGroupDeletion: PropTypes.object,
  holdGroupDeletionChanged: PropTypes.func.isRequired,
  deleteHoldGroup: PropTypes.func.isRequired,
  holdToConfirm: PropTypes.object,
  holdToConfirmChanged: PropTypes.func.isRequired,
  userChangedDoorsTimeChanged: PropTypes.func.isRequired,
  userChangedEventEndTimeChanged: PropTypes.func.isRequired,
  convertHoldGroupToConfirm: PropTypes.func.isRequired,
  isConvertingHoldToConfirm: PropTypes.bool,
  venueOwnerships: PropTypes.array,
  rooms: PropTypes.array,
  eventTimeDefaults: PropTypes.object
};

export default HoldActionMenu;
